import type { GetTimezones } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useResolveTimezones() {
  return useQuery({
    queryFn: () =>
      apiClient.url(`/users/resolve-timezones`).get().json<GetTimezones>(),
    queryKey: ["timezones"],
  });
}
